"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_utils_price_format_1 = require("@saatva-bits/pattern-library.utils.price-format");
const ProductSummary_module_scss_1 = __importDefault(require("./ProductSummary.module.scss"));
const PriceStrikeThrough = ({ lowestPrice, lowestPriceDiscount, className, discountClassName }) => {
    const priceContent = (0, pattern_library_utils_price_format_1.formatCurrency)(lowestPrice);
    const hasDiscount = lowestPrice !== lowestPriceDiscount;
    const discountContent = hasDiscount && (0, pattern_library_utils_price_format_1.formatCurrency)(lowestPriceDiscount);
    const mainPrice = hasDiscount ? discountContent : priceContent;
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(ProductSummary_module_scss_1.default.price, className), children: [mainPrice, discountContent && ((0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(ProductSummary_module_scss_1.default.strikeThrough, discountClassName), children: priceContent }))] }));
};
PriceStrikeThrough.propTypes = {
    className: prop_types_1.default.string,
    discountClassName: prop_types_1.default.string,
    lowestPrice: prop_types_1.default.number.isRequired,
    lowestPriceDiscount: prop_types_1.default.number.isRequired
};
const ProductSummary = ({ title, subtitle, product, promotionDeps, selectionDeps }) => {
    const { useGetDiscounts } = promotionDeps;
    const { useProductState } = selectionDeps;
    const { getDiscounts } = useGetDiscounts();
    const { price, sku, variantUrl } = useProductState(product.productCode, ['price', 'sku', 'variantUrl', 'bundledVariants', 'category']);
    let productsForDiscount = [{
            sku,
            parentSku: product.productCode,
            quantity: 1,
            price
        }];
    const { fullPrice, finalPrice } = getDiscounts(productsForDiscount);
    return ((0, jsx_runtime_1.jsxs)("section", { className: ProductSummary_module_scss_1.default.container, children: [(0, jsx_runtime_1.jsx)("h2", { className: `t-heading1 t-color ${ProductSummary_module_scss_1.default.title}`, children: (0, jsx_runtime_1.jsx)("a", { href: variantUrl, children: title }) }), (0, jsx_runtime_1.jsx)("div", { className: ProductSummary_module_scss_1.default.subtitle, children: subtitle }), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(ProductSummary_module_scss_1.default.price), children: (0, pattern_library_utils_price_format_1.formatCurrency)(fullPrice) })] }));
};
ProductSummary.propTypes = {
    title: prop_types_1.default.string.isRequired,
    subtitle: prop_types_1.default.string.isRequired,
    /** Interface for promo context dependencies */
    promotionDeps: prop_types_1.default.shape({
        useGetDiscounts: prop_types_1.default.func
    }),
    /** Interface for selection context dependencies */
    selectionDeps: prop_types_1.default.shape({
        useProductState: prop_types_1.default.func,
        useAttributeOptions: prop_types_1.default.func,
    }),
    product: prop_types_1.default.shape({
        productCode: prop_types_1.default.string,
        lowestPrice: prop_types_1.default.number,
        highestPrice: prop_types_1.default.number,
        configurableAttributes: prop_types_1.default.arrayOf(prop_types_1.default.string),
        variants: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            sku: prop_types_1.default.string,
            productCode: prop_types_1.default.string,
            category: prop_types_1.default.string,
            price: prop_types_1.default.number,
        }))
    })
};
exports.default = ProductSummary;
//# sourceMappingURL=ProductSummary.js.map